import type { Client, RequestContext } from "../client";
import type { GitRef, DeleteProjectTemplateCommand, ModifyProjectTemplateCommand, NewProjectTemplate, ProjectTemplateListSummaryResource, ProjectTemplateSummary, ProjectTemplateResource } from "../resources";
export class ProjectTemplatesRepository {
    protected readonly client: Client;
    protected readonly context: RequestContext;
    constructor(client: Client, requestContext: RequestContext) {
        this.client = client;
        this.context = requestContext;
    }
    summaries() {
        return this.client.get<ProjectTemplateListSummaryResource[]>(this.context, "~/api/platformhub/projecttemplates/summaries");
    }
    get(slug: string, gitRef: string | undefined) {
        return this.client.get<ProjectTemplateResource>(this.context, "~/api/platformhub/{gitRef}/projecttemplates/{slug}", { slug, gitRef });
    }
    del(blueprint: DeleteProjectTemplateCommand) {
        return this.client.post(this.context, "~/api/platformhub/projecttemplates/delete-by-id", blueprint);
    }
    add(projectTemplate: NewProjectTemplate, gitRef: GitRef) {
        return this.client.post<ProjectTemplateResource>(this.context, "~/api/platformhub/{gitRef}/projecttemplates", projectTemplate, { gitRef });
    }
    modify(blueprint: ModifyProjectTemplateCommand) {
        return this.client.put<ProjectTemplateResource>(this.context, "~/api/platformhub/projecttemplates/{blueprintId}", blueprint, { blueprintId: blueprint.Id });
    }
    getPaginatedTemplates(projectTemplatesPageFilter: GetProjectTemplatesBffRequest): Promise<GetProjectTemplatesBffResponse> {
        return this.client.get<GetProjectTemplatesBffResponse>(this.context, "~/api/platformhub/{gitRef}/projecttemplates{?skip,take,partialName}", projectTemplatesPageFilter);
    }
}
export function getProjectTemplateIconUrl(projectTemplate: ProjectTemplateSummary) {
    const projectTemplateSlug = encodeURIComponent(projectTemplate.Slug);
    const gitRef = encodeURIComponent(projectTemplate.GitRef);
    return projectTemplate.Icon ? `api/platformhub/projecttemplates/${gitRef}/${projectTemplateSlug}/icon?cb=${projectTemplate.Icon.Id}-${projectTemplate.Icon.Color}` : `api/platformhub/projecttemplates/${gitRef}/${projectTemplateSlug}/icon`;
}
export type GetProjectTemplatesBffRequest = {
    skip: number;
    take: number;
    partialName?: string;
    gitRef: string;
};
export interface GetProjectTemplatesBffResponse {
    ProjectTemplates: ProjectTemplateSummary[];
    TotalResults: number;
    ItemsPerPage: number;
    TotalNoOfProjectTemplates: number;
}
